// import { Select } from '@material-ui/core';
import React, { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import styled from "styled-components";
import { Badge } from "@material-ui/core";
import "./css/tabrik.css";
import ThumbNail from "./ThumbNail";
import html2canvas from "html2canvas";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import { toast, ToastContainer } from "react-toastify";

const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0px;
  position: relative;
  padding: 0;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const Header = styled.div`
  background-color: rgb(109 208 132);
  border: none;
  min-height: 290px;
  height: auto;
  text-align: center;
  color: white;
  justify-content: center;
  padding: 55px 50px 75px 50px;
  font-size: 20px;
`;

const Cards = styled.div`
  height: 100%;
  position: relative;
  margin: 5%;
  margin-bottom: 15rem;
  margin-top: 15rem;
  padding: 0px;
`;

const SingleCard = styled.div`
  min-height: 570px;
  height: auto;
  background: #e9e9e9;
  background: linear-gradient(180deg, white, #e4e3e3);

  -webkit-box-shadow: 0px 0px 25px 2px rgba(49, 46, 14, 0.38);
  box-shadow: 0px 3px 5px 2px rgba(49 46 14 / 10%);

  flex: 1;
  top: 100px;
  margin: 0px;
  padding: 5px;
  border-radius: 20px;

  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const IconContainer = styled.div`
  top: ${(props) => props.top};
  position: absolute;
  left: 0;
  right: 0;
  margin-top: 1rem;
`;

const Icon = styled.img`
  max-width: 15rem;
  height: auto;
  object-fit: contain;
  width: 100%;
`;

const TitleIcons = styled.img`
  max-width: 30rem;
  height: auto;
  object-fit: contain;
  width: 100%;
`;

const Title = styled.h1`
  font-size: ${(props) => (props.font ? props.font : "18px")};
  margin-top: 10px;
  color: #7d7d80;
  font-weight: ${(props) => (props.font ? "" : "bold")};
`;

const Input = styled.input`
  width: 90%;
  border-radius: 10px;
  height: 50px;
  margin: 20px;
  border: 1px solid #ccc;
  padding: 10px;
`;

const Select = styled.select`
  width: 90%;
  height: 45px;
  border-radius: 10px;
  padding: 10px;
  background-color: white;
  border: 1px solid #ccc;
`;

const TextArea = styled.textarea`
  width: 90%;
  height: 100px;
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #ccc;
`;

const Button = styled.button`
  width: ${(props) => (props.width ? props.width : "80%")};
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: ${(props) => props.color};
  margin-top: 3%;
  color: white;
`;

const GuidedText = styled.h6`
  line-height: 23px;
  margin-top: 1rem;
  margin-block: auto;
  padding-inline: 10px;
`;

function Tabrik() {
  const [sender, setSender] = useState("");
  const [reciever, setReciever] = useState("");
  const [message, setMessage] = useState("");
  const [select, setSelect] = useState(0);
  const [disabledMessage, setDisabledMessage] = useState(false);
  const [step, setStep] = useState(1); // 1 -> step 1 , 2 -> step 2
  const [loading, setLoading] = useState(false); // 1 -> step 1 , 2 -> step 2

  const messageList = [
    {
      id: 0,
      type: "rasmi",
      msg: "",
    },
    {
      id: 1,
      type: "rasmi",
      msg:
        "فرا رسیدن سال نو و نوروز باستانی را به شما و خانواده محترمتان شادباش گفته و برایتان سالی سرشار از سلامتی، فراوانی، بی نیازی، کوشش و آرامش همراه با دلخوشی آرزومندم.",
    },
    {
      id: 2,
      type: "friendly",
      msg:
        "هرسال در بزنگاه بهار مجالیست برای سپاسگزاری از معلمی که اندیشیدن را به من آموخت نه اندیشه‌ها را..." +
        "\nامیدوارانه گام می نهیم به سال و قرنی نو" +
        "\nسال نو مبارک، زندگی تان بهاری",
    },
    {
      id: 3,
      type: "friendly",
      msg:
        "پروردگارا! در این روز‌های پایانی سال" +
        "\n به خواب عزیزانمان آرامش، به بیداری‌شان آسایش" +
        "\nبه زندگیشان عافیت، به عمرشان عزت،" +
        "\nو به وجودشان صحت عطا بفرما",
    },
    {
      id: 4,
      type: "friendly",
      msg:
        "بهار است و گل ها لبخند زمین هستند" +
        "\nآغاز لبخند زمین را به تو تبریک می گویم مادر مهربانم" +
        "\nسال نو مبارک",
    },
    {
      id: 5,
      type: "friendly",
      msg:
        "دل را از پیله ی قهرش بیرون خواهم کشید" +
        "\nدسته گلی از یاس و باران برایت خواهم چید" +
        "\nنقش لبخندرا بر چهره ی زیبایت خواهم پاشید" +
        "\nتا برایت پیام شادباشی بنویسم" +
        "\nپدرم نوروزت مبارک",
    },
    {
      id: 6,
      type: "friendly",
      msg:
        "دوست داشته باشید و زندگی کنید ،" +
        "\nزمان همیشه از آن شما نیست..." +
        "\nاگر چه یادمان میرود که عشق تنها دلیل زندگی ست" +
        "\nاما خداروشکر که نوروز هرسال این فکر را به یادمان می اورد",
    },
    {
      id: 7,
      type: "friendly",
      msg:
        "نوروز، نماد جاودانِ نو شدن است" +
        "\nتجدید جوانیِ جهان کهن است" +
        "\nزین ها همه خوب تر که هر نو شدنش" +
        "\nیادآور نام پاک ایرانِ من است",
    },
    {
      id: 8,
      type: "friendly",
      msg:
        "برآمد باد صبح و بوی نوروز" +
        "\nبه کام دوستان و بخت پیروز" +
        "\nمبارک بادت این سال و همه سال" +
        "\nهمایون بادت این روز و همه روز",
    },
    {
      id: 9,
      type: "friendly",
      msg:
        "عید است ولی بدون او غم داریم / عاشق شده ایم و عشق را کم داریم" +
        "\nای کاش که این عید ظهورش برسد / اینگونه هزار عید با هم داریم" +
        "\nاللهم عجل لولیک الفرج" +
        "\nسال نو مبارک",
    },
  ];

  // useEffect(() => {
  //     if (select === 0) {
  //         setDisabledMessage(false)
  //     } else {
  //         setMessage(true)
  //     }
  // }, [select]);
  const printRef = React.useRef();

  const handleDownloadImage = async () => {
    setLoading(true);
    const d = {
      from: sender,
      to: reciever,
      content: message,
    };
    axios.post("https://ebus.ir/service/api/v1/cardPostal", d);
    const element = printRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL("image/jpg");
    const link = document.createElement("a");
    // const blob = await (await fetch(data)).blob();
    // const filesArray = [
    //   new File([blob], "animation.png", {
    //     type: blob.type,
    //     lastModified: new Date().getTime(),
    //   }),
    // ];
    // const shareData = {
    //   files: filesArray,
    // };

    // console.log(shareData);

    if (typeof link.download === "string") {
      link.href = data;
      link.download = "image.jpg";
      document.body.appendChild(link);
      link.click();
      console.log(data);

      setLoading(false);

      document.body.removeChild(link);
    } else {
      setLoading(false);

      window.open(data);
    }
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelect(value);
    setMessage(messageList.at(value).msg);
    if (value === 0) {
      setMessage("متن پیام...");
    } else {
      setMessage(messageList.at(value).msg);
    }
  };

  const handleButtonStep = (event) => {
    if (reciever.length < 1 || sender.length < 1 || message.length < 1) {
      toast.warning("لطفا نام فرستنده و گیرنده و متن پیام را وارد کنید");
    } else {
      setStep(2);
    }
  };

  return (
    <Container>
      <ToastContainer rtl={true} />
      <Header>
        <IconContainer top="8%">
          <TitleIcons
            alt="sal-no"
            src={toAbsoluteUrl("./media/landings/postCard/salno.png")}
          />
          <GuidedText>
            امسال میتونی تبریک عید اختصاصی خودت رو درست کنیو به دوست ها و
            آشناهات بفرستی وخوشحالشون کنی.
          </GuidedText>
        </IconContainer>
      </Header>

      {step === 1 ? (
        <Cards>
          <div className="row">
            <SingleCard>
              <div className="row">
                <IconContainer top="-15%">
                  <Icon
                    alt="sabze" src={toAbsoluteUrl("./media/landings/postCard/sabze.png")}
                  />
                </IconContainer>
              </div>
              <div className="row" style={{ marginTop: "9.5rem" }}>
                <div className="col-12">
                  <Badge badgeContent={1} color="primary" />
                  <Title>اول نام فرستنده و گیرنده رو وارد کن</Title>

                  <div className="row">
                    <div className="col-12 col-md-6">
                      <Input
                        onChange={(e) => setSender(e.target.value)}
                        placeholder="نام فرستنده"
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <Input
                        onChange={(e) => setReciever(e.target.value)}
                        placeholder="نام گیرنده"
                      />
                    </div>
                  </div>

                  <br />
                </div>

                <div className="col-12">
                  <h1>
                    <Badge badgeContent={2} color="primary" />
                  </h1>
                  <Title>حالا متن تبریک رو بنویس</Title>
                  <Title font="14px">
                    اگه بخوای میتونی از طریق لیست زیر از متن های اماده استفاده
                    کنی
                  </Title>
                  <br />
                  <div className="row">
                    <div className="col-lg-12">
                      <Select
                        name="isVerified"
                        value={select}
                        onChange={handleSelectChange}
                      >
                        <option selected value={0}>
                          خودت بنویس
                        </option>
                        <option selected value={1}>
                          تبریک رسمی
                        </option>
                        <option value={2}>تبریک به معلم</option>
                        <option value={3}>تبریک به خانواده</option>
                        <option value={4}>تبریک به مادر</option>
                        <option value={5}>تبریک به پدر</option>
                        <option value={6}>تبریک به همکار</option>
                        <option value={7}>تبریک شعر</option>
                        <option value={8}>تبریک شعر</option>
                        <option value={9}>تبریک مذهبی</option>
                      </Select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <TextArea
                        value={message}
                        disabled={select == 0 ? false : true}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <Button
                    width="30%"
                    color="#00d26a"
                    onClick={handleButtonStep}
                  >
                    مرحله بعد
                  </Button>
                </div>
              </div>
            </SingleCard>
          </div>
        </Cards>
      ) : (
        <Cards>
          <SingleCard>
            <div className="row">
              <IconContainer top="-8rem">
                <Icon
                  src={toAbsoluteUrl("./media/landings/postCard/egg.png")}
                />
              </IconContainer>
            </div>

            <div className="row" style={{ marginTop: "7rem" }}>
              <div className="col-12">
                <Badge badgeContent={3} color="primary" />
                <Title>یکی از تم ها رو انتخاب کن</Title>
              </div>

              <div className="col-12">
                <ThumbNail
                  printRef={printRef}
                  sender={sender}
                  reciever={reciever}
                  message={message}
                />
              </div>
            </div>

            <div className="col-12 col-md-6 d-flex flex-wrap mx-auto p-0">
              <div className="col-12 col-md-3 p-1">
                <Button
                  onClick={() => {
                    setStep(1);
                  }}
                  color="#f1f1f1"
                  className="w-100 mt-1"
                >
                  <span style={{ color: "darkgray" }}>ویرایش</span>
                </Button>
              </div>
              <div className="col-12 col-md-9 p-1">
                <Button
                  color="#00d26a"
                  onClick={handleDownloadImage}
                  className="w-100 mt-1"
                >
                  {loading ? (
                    <CircularProgress color="white" size={20} />
                  ) : (
                    "ذحیره عکس"
                  )}
                </Button>
              </div>
              <div className="col-12 p-1">
                <Button
                  onClick={() => {
                    setStep(1);
                  }}
                  color="lightgrey"
                  className="w-100"
                >
                  میخوام یکی دیگه بسازم
                </Button>
              </div>
            </div>
          </SingleCard>
        </Cards>
      )}
    </Container>
  );
}

export default Tabrik;
